import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { BBadge } from "bootstrap-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
export default /*#__PURE__*/ _defineComponent({
    __name: 'IncludedBadge',
    props: {
        itemName: null,
        included: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        library.add(faCheck, faTimes);
        const variant = computed(() => {
            return props.included ? "primary" : "secondary";
        });
        return { __sfc: true, props, variant, BBadge, FontAwesomeIcon };
    }
});
